module.exports = __webpack_public_path__ + "img/28ne.0d1ba1cf.svg";